import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { getDayNameShort, getDate } from "../../utils/date";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    [breakpoints.down("xs")]: {
      marginRight: typography.pxToRem(8)
    },
    [breakpoints.up("sm")]: {
      marginRight: typography.pxToRem(20)
    }
  },
  title: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14)
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(19)
    },
    fontWeight: "normal",
    lineHeight: 0.84,
    letterSpacing: 0.41,
    textAlign: "center",
    color: palette.text.hintThird
  },
  dayNumber: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14)
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(19)
    },
    fontWeight: "normal",
    lineHeight: "normal",
    letterSpacing: 0.36,
    textAlign: "center",
    color: palette.text.hintThird
  },
  active: {
    background: palette.primary.main,
    borderRadius: "50%",
    "& p:first-child": {
      color: "#fff"
    },
    pointerEvents: "none"
  },
  dayNumberContainer: {
    [breakpoints.down("xs")]: {
      height: typography.pxToRem(36),
      width: typography.pxToRem(36)
    },
    [breakpoints.up("sm")]: {
      height: typography.pxToRem(56),
      width: typography.pxToRem(56)
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: typography.pxToRem(19),
    borderRadius: "50%"
  },
  hover: {
    cursor: "pointer",
    "&:hover": {
      background: palette.primary.main,
      "& p:first-child": {
        color: "#fff"
      }
    },
    transition: "background-color 0.5s ease-out"
  }
}));

const DatePickerDay = ({
  day,
  setActiveDay,
  isActive,
  onSelect
}) => {
  const styles = useStyles();

  const onClick = () => {
    onSelect ? onSelect(day) : setActiveDay(day);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    className: styles.container,
    "data-testid": "date-picker-day"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title,
    "data-testid": "date-picker-day-dayinweek"
  }, getDayNameShort(day).toUpperCase()), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.dayNumberContainer, isActive && styles.active, styles.hover),
    onClick: onClick,
    "data-testid": `date-picker-day-dayinmonth${isActive ? "-active" : ""}`
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.dayNumber
  }, getDate(day))));
};

export default DatePickerDay;